import { AloDrift, IAloDriftConstParam } from '@/models/alo/AloDrift'
import { AloBaseArray, IAloBaseArray } from './AloBaseArray'

export interface IAloYoConstParam {
    yosId:number|null
    yosCycle:number|null
    batteries:number|null
    heading:number|null
    zb:number|null
    zt:number|null
    alt:number|null
    pu:number|null
    pd:number|null
    bu:number|null
    bd:number|null
    rate:number|null
    driftArray:Array<IAloDriftConstParam>
    yoGpsLat:number|null
    yoGpsLon:number|null
    yoGpsDatTime:string
    cr:number|null
    cf:number|null
}

export class AloYo {    

    public yosId:number|null
    public yosCycle:number|null
    public batteries:number|null
    public heading:number|null
    public zb:number|null
    public zt:number|null
    public alt:number|null
    public pu:number|null
    public pd:number|null
    public bu:number|null
    public bd:number|null
    public rate:number|null
    public driftArray:Array<AloDrift>
    public yoGpsLat:number|null
    public yoGpsLon:number|null
    public yoGpsDatTime:Date
    public cr:number|null
    public cf:number|null    

    constructor({yosId,yosCycle,batteries,heading,zb,zt,alt,pu,pd,bu,bd,rate,driftArray=[],yoGpsLat,yoGpsLon,yoGpsDatTime,cr,cf}:IAloYoConstParam = {} as IAloYoConstParam) {
        this.yosId = yosId
        this.yosCycle = yosCycle
        this.batteries = batteries
        this.heading = heading        
        this.zb = zb
        this.zt = zt
        this.alt = alt
        this.pu = pu
        this.pd = pd
        this.bu = bu
        this.bd = bd
        this.rate = rate
        this.driftArray = driftArray.map(drift => new AloDrift(drift))
        this.yoGpsLat = yoGpsLat
        this.yoGpsLon = yoGpsLon        
        this.yoGpsDatTime = new Date(yoGpsDatTime)
        this.cr = cr ?? null
        this.cf = cf ?? null
    }

    public get isUnderWater() {    
        return   !this.heading && 
                 !this.zb && 
                 !this.zt && 
                 !this.alt && 
                 !this.pu && 
                 !this.pd && 
                 !this.bu && 
                 !this.bd && 
                 !this.rate && 
                 !this.yoGpsLat && 
                 !this.yoGpsLon &&
                 this.yoGpsDatTime.toString() == 'Invalid Date'
    }
   

    static createAloYoArray(datas:IAloBaseArray) {
        return new AloBaseArray(AloYo,datas)
    }

}